import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=502de06e&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"
import style0 from "./Headline.vue?vue&type=style&index=0&id=502de06e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502de06e",
  null
  
)

export default component.exports